import React, { useRef } from 'react';
import useClickOutside from '../../../hooks/useClickOutside';
import styles from './UserModal.module.css';

const UserModal = ({ isOpen, onClose, onSubmit, formValues, handleInputChange, isEditMode, error }) => {
  const modalRef = useRef(null);

  useClickOutside(modalRef, onClose, isOpen);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content} ref={modalRef}>
        <button className={styles.close} onClick={onClose}>X</button>
        <form onSubmit={onSubmit} className={styles.form}>
          <h2 className={styles.formTitle}>{isEditMode ? 'Editar Usuario' : 'Crear Usuario'}</h2>
          <div className={styles.formGroup}>
            <input
              type="text"
              name="nombre"
              className={styles.formInput}
              placeholder="Nombre"
              value={formValues.nombre}
              onChange={handleInputChange}
            />
          </div>
          <div className={styles.formGroup}>
            <input
              type="email"
              name="email"
              className={styles.formInput}
              placeholder="Email"
              value={formValues.email}
              onChange={handleInputChange}
            />
          </div>
            <div className={styles.formGroup}>
              <input
                type="password"
                name="password"
                className={styles.formInput}
                placeholder="Password"
                value={formValues.password}
                onChange={handleInputChange}
              />
            </div>
          <div className={styles.formGroup}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="isStaff"
                className={styles.checkbox}
                checked={formValues.isStaff}
                onChange={handleInputChange}
              />
              Es Admin
            </label>
         
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="estado"
                className={styles.checkbox}
                checked={formValues.estado}
                onChange={handleInputChange}
              />
              Estado Activo
            </label>
          </div>
          {error && <p className={styles.formError} role="alert">{error}</p>}
          <button type="submit" className={styles.submit}>
            {isEditMode ? 'Editar Usuario' : 'Crear Usuario'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserModal;